<template>
    <div>
    <div class="py-3"></div>
    
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >    
    <v-toolbar-title>이미지 퀴즈(광고용 번들)</v-toolbar-title>
        <v-spacer/>
        <v-btn
            color="cyan"
            small
            fab
            @click="OnClick_CreateItem"
        >
            <v-icon 
            color= "white"
            >mdi-plus</v-icon>
        </v-btn>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="quizbundle_list_all"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.pid}}</td>
            <td>{{row.item.title}}</td>
            <td>{{row.item.regist_user}}</td>
            <!-- 추가되는 시작,종료일시 -->
            <!-- <td>{{row.item.dt_regist}}</td> -->        
            <td>{{"https://quiz.snapplay.io/quizview_ad?pid=" + row.item.pid}}</td>
            <td>
                <v-btn width="80px"
                :color="row.item?.commit_path === '' ? 'grey':'indigo'"
                class='white--text'
                @click="OnCopyItem(row.item)">링크복사!</v-btn>
            </td>
            <td>
                <v-switch
                v-model="row.item.used"
                :true-value="1"
                :false-value="0"
                color="indigo"
                label=""
                hide-details
                @change="(value) => OnSwitchChange(row.item, value)"
                />
            </td>
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card>

    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5 mb-3">
            광고 퀴즈번들 생성하기
        </v-card-title>

        <v-card-text>
            <v-text-field 
                label="퀴즈 타이틀"
                v-model="quiz_title_text" 
                outlined
                dense
            ></v-text-field>
            
        <!-- 왼쪽: 이미지 업로드 입력 -->
    <v-row>
        <v-col md="4" class="text-h6 mb-3">
            퀴즈 갯수 설정
        </v-col>
        <v-col>
            <v-text-field 
                label="퀴즈 갯수"
                v-model="dialog_quiz_count" 
                outlined
                dense
                style="width:120px;"
            ></v-text-field>                    
        </v-col>        
        <v-col>
            <v-btn 
            width="120px" 
                    :color="'blue'"                     
                    :class="'white--text'"
                    @click="OnLoadRandomQuiz()"
                    >
                    랜덤채우기
                </v-btn>
        </v-col>
    </v-row>
      <v-row>
        <v-list>
            <v-list-item-group>
                <v-list-item
                v-for="(itemdata, index) in dialog_quizlist_info"
                :key="itemdata.pid || index"
                class="custom-list-item"
                @click.stop
                >
                <span style="margin-left: 10px; margin-right: 10px; font-weight: 900; font-size: 20px; color: blue;">{{index + 1}}</span>                
                <span style="width:300px;margin-left: 20px; margin-right: 10px; font-weight: 900; font-size: 20px;" >{{itemdata.correct }}</span>
                <span style="margin-left: 10px; margin-right: 10px;">
                    <!-- v-model="itemdata.need_ad" -->
                    <!-- <v-checkbox
                        
                        :label="'광고'"
                        class="custom-checkbox"
                        hide-details
                        @change="onCheckboxChange(index, itemdata)"
                    ></v-checkbox> -->
                    <div style="display: flex; align-items: center;">
                        <input
                            type="checkbox"
                            :id="'checkbox-' + index"
                            :checked="itemdata.checked"
                            @change="onCheckboxChange($event.target.checked, index, itemdata)"
                            class="large-checkbox"
                        />
                        <label
                            :for="'checkbox-' + index"
                            style="font-size: 16px; margin-left: 5px; font-weight: 900;"
                        >
                            광고
                        </label>
                        </div>
                </span>
                </v-list-item>
            </v-list-item-group>
            </v-list>
      </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="CancelEdit"
          >
            취소
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="CreateQuizBundle"
          >
            SAVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog 
        v-model="dialog_search"
        max-width="800">
        <v-card>
        <v-card-title class="text-h5 mb-3">
            광고 퀴즈번들 생성하기
        </v-card-title>
        </v-card>        
    </v-dialog>
    </div>

</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
const { s3_upload , FileUpload_JSON} = require("../../util/fileutil");
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',

    data: () => ({
        dialog_title_text :'',
        dialog : false,
        dialog_quiz_count:5,
        dialog_quizlist_info:[],
        
        checkedItems: Array(5).fill(false), // 체크박스 상태 관리
        dialog_checked_state :[],

        dialog_search:false,



        loadingData:false,        
        create_date:'',
        quiz_title_text : '',

        imageFile : null, 
        headers: [            
            { text: '고유번호', value: 'pid' },
            { text: '타이틀', value: 'title' },            
            { text: '작성자', value: 'admin_user' },
            { text: '링크', value: 'link' },            
            { text: '링크만들기', value: 'commit' },
            { text: '사용', value: 'use' },
            // { text: '등록하기', value: 'dt_export' },
        ],
        quizbundle_list_all:[],
        

        selected_editing_item:{},
    }),

    created()
    {    
        this.LoadQuizBundleList();    
    },

    methods:{
        ...mapActions([
            'GET_IMG_QUIZLIST_AD',
            'GET_RANDOM_IMG_QUIZLIST_AD',
            'CREATE_QUIZLIST_AD',
            'DELETE_QUIZLIST_AD',
            'UPDATE_AD_QUIZ_STATE',
        ]),
        onCheckboxChange(isChecked , index, item) {
            item.need_ad = isChecked?1:0;
        },
        LoadQuizBundleList(){   
            console.log("JSJSJSJSJS "+JSON.stringify(this.quizbundle_list_all ));
            this.GET_IMG_QUIZLIST_AD({}).then((body_data)=>{
                this.loadingData = false; 
                this.quizbundle_list_all = body_data.result;
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        ShowDialog_CreateBundle()
        {
            this.imageFile = null;
            this.dialog = false;    
        },
        async CreateQuizBundle()
        {
            if(this.quiz_title_text == "")
            {
                alert("퀴즈 타이틀 텍스트를 입력해주세요");
                return;
            }

            this.loadingData = true;
            this.dialog = false;    
            //create_quizlist_ad
            let title = this.quiz_title_text;
            let quiz_data = this.dialog_quizlist_info;
            var newFileName = "snapquiz/quiz_data_ad/"+this.Utill_CreateNewImageName('temp.json');            
            if(await FileUpload_JSON(quiz_data, newFileName))
            {
                this.loadingData = false;
                    let commit_path = newFileName;                
                    this.CREATE_QUIZLIST_AD({title , quiz_data ,  commit_path}).then((body_data)=>{
                        this.loadingData = false;
                        this.LoadQuizBundleList();
                    })
                    .catch((err)=>{
                        this.error = err;
                        console.log(err);
                    })
            }         
        },
      
        
        OnClickEdit_Item(item)
        {//아이템을 수정하려는 경우에 호출한다 
            this.$router.push({
                path: '/quizedit',
                query: {
                    pid: item,
                }
            });
        },

        OnClick_CreateItem()
        {
            this.dialog_title_text = "퀴즈 타이틀";
            this.dialog = true;
        },

        CancelEdit()
        {
            this.dialog = false;    
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        OnLoadRandomQuiz()
        {
            let item_count = this.dialog_quiz_count;
            this.GET_RANDOM_IMG_QUIZLIST_AD({item_count }).then((body_data)=>{
                console.log(JSON.stringify(body_data));
                //this.dialog_checked_state[pid]
                //this.dialog_quizlist_info = body_data.result;
                this.dialog_quizlist_info = body_data.result.map(item => ({
                    ...item,
                    need_ad: false, // 체크 상태 초기화
                }));
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        Utill_CreateNewImageName(originalFileName)
        { // 확장자 추출
            const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.')); // 예: ".png", ".jpg"
            // 랜덤 문자열 생성 (16자)
            const randomString = Math.random().toString(36).substring(2, 18); // 예: "5g8n4z6qx0ld3y7w"
            // 새 파일 이름 생성
            return randomString + fileExtension; // 예: "5g8n4z6qx0ld3y7w.png"
        },        
        OnFillRandomQuiz()
        {

        },
        OnCopyItem(item)
        {
            console.log(JSON.stringify(item));
            if(item.commit_path != "")
            {   
                // navigator.clipboard.writeText(fullLink).then(() => {
                //     console.log("Text copied to clipboard:", fullLink);
                // }).catch(err => {
                //     console.error("Failed to copy text to clipboard:", err);
                // });
                let fullLink = "https://quiz.snapplay.io/quizview_ad?pid=" + item.pid;
                console.log(fullLink);
                let textArea = document.createElement("textarea");
                textArea.value = fullLink;
                textArea.style.display = "fixed";
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                return new Promise((res, rej) => {
                    document.execCommand('copy') ? res() : rej();
                    textArea.remove();
                    alert("Copied!")
                });
               // alert("복사완료 : " + fullLink);
            }
            
        },
        OnSwitchChange(item, toggleValue)
        {
            let pid = item.pid;
            let quiz_state = toggleValue;
            this.UPDATE_AD_QUIZ_STATE({pid,  quiz_state }).then((body_data)=>{
                this.LoadQuizBundleList();
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
      
    },
    computed: {
        
        quizItems() {
            if (this.dialog_quizlist_info.length > 0) {
            // dialog_quizlist_info에 데이터가 있는 경우 대체
            return this.dialog_quizlist_info;
            } else {
            // 데이터가 없는 경우 기본값 반환
            return Array.from({ length: this.dialog_quiz_count }, (_, i) => ({
                id: i + 1,
                title: `Quiz ${i + 1}`,
            }));
            }
        },
    },
    components:{
    },
    watch :{
        dialog_quiz_count(newCount) {
            if(newCount == '')
                newCount = 0;
            if(newCount > 20)
            {
                this.dialog_quiz_count = 20;
                newCount = 20;
                alert('20개 미만으로 설정해 주세요');
            }    
            //this.dialog_quizlist_info = [newCount];
            // this.dialog_quizlist_info = Array.from({ length: newCount }, (_, i) => ({
            // }));
            this.checkedItems = Array(newCount).fill(false);            
        },
        
    }
};
</script>
<style>
.custom-list-item {
  margin: 0px !important;
  padding: 0px !important;  
}

.custom-list-item-content {
  padding: 0px !important;
  margin: 0px !important;
}

.custom-checkbox {
  margin: 0px !important;
  padding: 0px !important;
}

.large-checkbox {
  width: 20px;  /* 너비 */
  height: 20px; /* 높이 */
  margin: 10px;
}
</style>

